<button class="m-2" pButton pRipple label="Imprimir Comprobante" icon="pi pi-print" (click)="createPDF()"></button>